import { LanguageContext } from 'context/LanguageContext'
import React, { useContext, useEffect, useState } from 'react'
import './otpStyle.scss'

let resendTimer = null
const RESEND_TIMER = 30

const ResendButton = ({ getOTPSuccess, setOtpSuccess, onVerifyPhoneNumberClick, disabled }) => {
    const { strings } = useContext(LanguageContext)
    const [timer, setTimer] = useState(RESEND_TIMER)

    const startResendTimer = () => {
        resendTimer = setInterval(() => {
            setTimer(val => val - 1)
        }, 1000)
    }

    useEffect(() => {
        if (getOTPSuccess) {
            setTimer(RESEND_TIMER)
            startResendTimer()
        }
        return () => resendTimer && clearInterval(resendTimer)
    }, [getOTPSuccess])

    useEffect(() => {
        if (timer === 0) {
            setOtpSuccess(false)
            resendTimer && clearInterval(resendTimer)
        }
    }, [timer])

    return (
        <button
            className={`${(timer || disabled) && 'disabled'} resend-btn`}
            onClick={onVerifyPhoneNumberClick}
            disabled={timer > 0 || disabled}
        >
            {timer && !disabled ? `${strings.resend_code}(${timer})` : `${strings.resend_code}`}
        </button>
    )
}

export default ResendButton
